  <template>
    <v-navigation-drawer
    v-model="show"
    app
    right
    color="primary"
    >
        <v-list
        subheader
        flat
        >
        <v-subheader class="mt-3 white--text">Search by Property Fields</v-subheader>
            <v-list-item >
                <v-list-item-content class="pb-0">
                    <v-select
                        v-model="search_field"
                        :items="search_fields"
                        item-text="label"
                        item-value="value"
                        outlined
                        chips
                        small-chips
                        label="Select the field"
                        clearable
                        dark
                    ></v-select>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="search_field != '' && search_field != undefined">
                <v-list-item-content class="pb-0">
                    <v-text-field
                        v-model="keyword"
                        light
                        :label="getSearchField"
                        @keyup.enter.native="submitSearch"
                        clearable
                        hide-details
                        outlined
                        dark
                        >
                    </v-text-field>  
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="search_field != '' && search_field != undefined && search_field != 'address' && search_field != 'property_id'">
                <v-list-item-content class="pb-0">
                    <v-select
                        v-model="search_type"
                        :items="search_types"
                        item-text="label"
                        item-value="value"
                        outlined
                        chips
                        small-chips
                        label="Select type"
                        clearable
                        dark
                    ></v-select>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content class="pb-0">
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateRangeText"
                            label="Date Range"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            clearable
                            dark
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="dates" no-title scrollable range>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="rangeCancel">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>   
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content class="pb-0">      
                    <v-btn
                        depressed 
                        tile
                        large
                        color="primary"
                        class="mx-0 mb-0 mt-0"
                        @click.prevent="submitSearch">
                    
                        <v-icon>mdi-magnify</v-icon>
                        Search
                    </v-btn>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        flat
        >
            <v-list-item >
                <v-list-item-content class="pb-0">
                    <v-autocomplete
                        v-model="building_type"
                        :items="building_types"
                        item-text="label"
                        item-value="value"
                        outlined
                        chips
                        small-chips
                        label="Building Type"
                        multiple
                        clearable
                        dark
                    ></v-autocomplete>
                </v-list-item-content>
            </v-list-item>
            <v-list-item >
                <v-list-item-content class="pb-0">
                    <v-autocomplete
                        v-model="construction_type"
                        :items="construction_types"
                        item-text="label"
                        item-value="value"
                        outlined
                        chips
                        small-chips
                        label="Construction Type"
                        multiple
                        clearable
                        dark
                    ></v-autocomplete>
                </v-list-item-content>
            </v-list-item>
            <v-list-item >
                <v-list-item-content class="pb-0">
                    <v-autocomplete
                        v-model="roof_type"
                        :items="roof_types"
                        item-text="label"
                        item-value="value"
                        outlined
                        chips
                        small-chips
                        label="Roof Type"
                        multiple
                        clearable
                        dark
                    ></v-autocomplete>
                </v-list-item-content>
            </v-list-item>
            <v-list-item >
                <v-list-item-content class="pb-0">
                    <v-autocomplete
                        v-model="user"
                        :items="users"
                        item-text="name"
                        item-value="id"
                        outlined
                        chips
                        small-chips
                        label="User"
                        multiple
                        clearable
                        dark
                    ></v-autocomplete>
                </v-list-item-content>
            </v-list-item>
            <v-list-item >
                <v-list-item-content class="pb-0">
                    <v-autocomplete
                        v-model="status"
                        :items="statuses"
                        item-text="label"
                        item-value="value"
                        outlined
                        chips
                        small-chips
                        label="Status"
                        multiple
                        clearable
                        dark
                    ></v-autocomplete>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['show', 'filter', 'routekey'],
  data: () => ({
    menu: false,
    keyword: "",
    building_type: [],
    construction_type: [],
    roof_type: [],
    user: [],
    dates: [],
    status: [],
    search_field: '',
    search_fields: [
        { 'value': 'property_id', label: 'Property ID' },
        { 'value': 'address', label: 'Address' },
        { 'value': 'sqft', label: 'SQFT' },
        { 'value': 'acres', label: 'Acres' },
        { 'value': 'year_purchased', label: 'Year Purchased' },
        { 'value': 'year_built', label: 'Year Built' },
        { 'value': 'purchased_price', label: 'Purchased Price' },
    ],
    search_type: 'equal',
    search_types: [
        { 'value': 'equal', label: 'Equal' },
        { 'value': 'greater', label: 'Greater Than' },
        { 'value': 'less', label: 'Less Than' },
    ]
  }),
  computed: {
        ...mapGetters({
            building_types: 'data/building_types',
            construction_types: 'data/construction_types',
            roof_types: 'data/roof_types',
            statuses: 'data/statuses',
            users: 'data/users',
        }),
        dateRangeText () {
          if(this.dates.length == 2) {
            if(this.dates[0] > this.dates[1]) {
                return this.dates[1] + '/' + this.dates[0]
            } else {
                return this.dates[0] + '/' + this.dates[1] 
            }
          } else {
              return this.dates[0]
          }
      },
      getSearchField() {
          if(this.search_field != '' ) {
                let sf = this.search_fields.filter( sfv => {
                    return sfv.value == this.search_field
                })

                return sf[0].label
          } else {
              return ''
          }
      }
  },
  created() {
      this.keyword = this.filter.keyword
      this.building_type = this.filter.building_type
      this.construction_type = this.filter.construction_type
      this.roof_type = this.filter.roof_type
      this.status = this.filter.status
      this.user = this.filter.user
      this.search_field = this.filter.search_field
      this.search_type = this.filter.search_type
  },
  watch: {
    show(newVal) { // watch it
        this.$emit('update-drawer', newVal)
    },
    keyword(newVal) {
        this.$emit('update-keyword', newVal)
    },
    building_type(newVal) {
        this.$emit('update-building_type', newVal)
    },
    construction_type(newVal) {
        this.$emit('update-construction_type', newVal)
    },
    roof_type(newVal) {
        this.$emit('update-roof_type', newVal)
    },
    user(newVal) {
        this.$emit('update-user', newVal)
    },
    search_field(newVal) {
        this.$emit('update-search_field', newVal)
    },
    search_type(newVal) {
        this.$emit('update-search_type', newVal)
    },
    status(newVal) {
        this.$emit('update-status', newVal)
    },
    dateRangeText(newVal) {
        this.$emit('update-daterange', newVal)
    },
  },
  methods: {
    submitSearch() {
        this.$emit('submit-search')
    },
    rangeCancel() {
        this.menu = false
        this.dates = []
    }
  }
}
</script>